export const TASK_KINDS = ['LIST', 'ONE_OFF'] as const;
export type TaskKind = (typeof TASK_KINDS)[number];

/** ISO weekdays: Monday is 1, Sunday is 7. A list that names none runs every day. */
export const TASK_WEEKDAYS = [1, 2, 3, 4, 5, 6, 7] as const;
export type TaskWeekday = (typeof TASK_WEEKDAYS)[number];
